













































import { User } from "../models/User";
import { Config } from "../utils/Config";
import InputField from "../core/Forms/InputField.vue";
import Multiselect from "vue-multiselect";
import EmployeSelect from "../core/Forms/EmployeSelect.vue";
import ContactSelect from "../core/Forms/ContactSelect.vue";
import { Contact } from "../models/Contact";

export default {
    name: "UserRolesEdit",
    components: { ContactSelect, EmployeSelect, InputField, Multiselect },
    props: {
        userData: Object,
    },
    data() {
        return {
            user: null,
            selected_roles: [],
            selected_employe: null,
            selected_syndic: null,
            options: [],
            vueMultiselectParams: Config.vueMultiselectParams,
            ERole: User.ERole,
            syndicSelectFilters: [Contact.EType.Syndic],
        };
    },
    created() {
        if (this.$isAdmin) {
            this.options = _.toArray(User.Role);
        } else {
            this.options = [User.Role[User.ERole.Mobile]];
        }
    },
    watch: {
        userData: {
            immediate: true,
            handler: function () {
                this.user = new User(this.userData);
                this.selected_roles = this.user.rolesDisplay;
                if (this.user.link_type_str == User.ELinkType.Employe) {
                    this.selected_employe = this.user.link;
                } else if (this.user.link_type_str == User.ELinkType.Syndic) {
                    this.selected_syndic = this.user.link;
                }
            },
        },
        "user.roles": function () {
            if (!_.isEqual(this.user.rolesDisplay, this.selected_roles)) {
                this.selected_roles = this.user.rolesDisplay;
            }
        },
        selected_roles: function () {
            this.user.roles = _.map(this.selected_roles, "id");
            this.$emit("updated-roles", this.user.roles);
        },
        selected_employe: function () {
            if (this.selected_employe) {
                this.user.link_type_str = User.ELinkType.Employe;
                this.user.link_id = this.selected_employe.id;
                this.$emit("updated-link", {
                    link_id: this.user.link_id,
                    link_type_str: this.user.link_type_str,
                });
            }
        },
        selected_syndic: function () {
            if (this.selected_syndic) {
                this.user.link_type_str = User.ELinkType.Syndic;
                this.user.link_id = this.selected_syndic.id;
                this.$emit("updated-link", {
                    link_id: this.user.link_id,
                    link_type_str: this.user.link_type_str,
                });
            }
        },
    },
};
